<template>
    <div class="notification is-warning">
        <button class="delete" @click="handleClose"></button>
        <p>
            Looks like you missed the stop at <b>{{ name }}.</b> </p>
        <p>Please go back to the stop to get your card.</p>
    </div>
</template>

<script setup lang="ts">
defineProps({
    name: String
});

const emit = defineEmits(['close']);

const handleClose = () => {
    console.log('Close button clicked');
    emit('close');
};
</script>
